export default __webpack_public_path__ + "static/media/AFHumaniza_Guia_Paciente_Oncologico.479bb3ac.pdf";